<template>
	<div class="RePresentation">
		<simple-wizard
			prevButtonText="Назад"
			nextButtonText="Вперед"
			finishButtonText="Завершить задачу"
		>
			<template v-slot:header>
				<h3 class="card-title">Презентация</h3>
				<h3 class="description">
					Выбери, настрой, отправь.
				</h3>
			</template>

			<wizard-tab :before-change="()=>tabChange('step1')">
				<template v-slot:label>
					<i class="tim-icons icon-square-pin"></i>
					<p>Объекты</p>
				</template>
				<slot ref="step1" name="step1"></slot>
				<!--
				<StpfstFlats
					ref="step1"
					@on-validated="onStepValidated"
					:masPresentationObjects="masPresentationObjects"
				/>
				-->
			</wizard-tab>

			<wizard-tab :before-change="() => tabChange('step2')">
				<template v-slot:label>
					<i class="tim-icons icon-settings"></i>
					<p>Настройки</p>
				</template>
				<slot ref="step2" name="step2"></slot>
				<!--
				<StpsndOpts
					ref="step2"
					@on-validated="onStepValidated"
					v-model="masViewOpts"
				/>
				-->
			</wizard-tab>

			<wizard-tab :before-change="() => tabChange('step3')">
				<template v-slot:label>
					<i class="tim-icons icon-send"></i>
					<p>Отправка</p>
				</template>
				<slot name="step3"></slot>
				<!--
				<StptrdSendNew
					ref="step3"
					@on-validated="onStepValidated"
					@sendpres="sendPress"
					:masContacts="masClient[0].contacts"
					:linkText="linkText"
				/>
				-->
			</wizard-tab>
		</simple-wizard>


		<!--tabs type="primary" 
			tabContentClasses="tab-opt"
			centered
			inline
			round			
			class="card card-plain">
			<tab-pane :id="'tb_1'" >
				<template v-slot:label>
				<span class="tab-label">
					<i class="tab-icon tim-icons icon-book-bookmark"></i><span>Презентация</span>
				</span>
				</template>
				
			</tab-pane>

			<tab-pane :id="'tb_2'" :disabled="bIsTabdisabled">
				<template v-slot:label>
				<span class="tab-label">
					<i class="tab-icon tim-icons icon-single-copy-04"></i><span>Сравнение</span>
				</span>
				</template>
				<div>

				</div>
			</tab-pane>

			<tab-pane :id="'tb_3'" :disabled="bIsTabdisabled">
				<template v-slot:label>
				<span class="tab-label">
					<i class="tab-icon tim-icons icon-send"></i><span>Отправленные презентации</span>
				</span>
				</template>
				<div class="sendPresentation">
					<collapse class="" activeIndexType="all">
						<collapse-item :title="presentTitle">
							<div class="presentInfo-row">
								<div class="flat-info">
									<p>ЖК Leningrad</p>
									<p>1-к.кв.</p>
									<p>№18е</p>
								</div>								
								<div class="flat-price">
									<p>Цена:</p>
									<p class="text-crossed">7 035 000 руб.</p>
									<p class="">7 035 000 руб.</p>
								</div>
								<div class="flat-status">
									<p>Статус: </p>
									<p class="text-success text-crossed">В продаже</p>
									<p class="text-danger">Продано</p>
								</div>
								<div class="flat-checked">
									<p>Просмотров: 2</p>
									<p>Последний просмотр 22.07.2020 в 12:30</p>
								</div>

							</div>
						</collapse-item>
					</collapse>

				</div>
			</tab-pane>
		</tabs-->

	</div>
</template>

<script>
// import { TabPane, Tabs } from 'src/components';
// import { Collapse, CollapseItem } from 'src/components';
import { Select, Option } from 'element-ui';
// import { BaseCheckbox } from 'src/components/index';
// import { BaseSwitch } from 'src/components/index';
// import ReFilter from "src/our_components/FilterPrinter/ReFilter.vue";
// import ReInputContact from "src/our_components/ReInputContact.vue";
// import PresentationNest from "src/our_modules/SearchSendObjects/PresentationNest.vue";
// import StpfstFlats from 'src/our_modules/SearchSendObjects/PresentationWizard/StpfstFlats.vue';
// import StpsndOpts from 'src/our_modules/SearchSendObjects/PresentationWizard/StpsndOpts.vue';
// import StptrdSendNew from 'src/our_modules/SearchSendObjects/PresentationWizard/StptrdSendNew.vue';
import { SimpleWizard, WizardTab } from 'src/components';

export default {
	name: 'RePresentation',
	components: {  
		// TabPane, 
		// Tabs,   
		// Collapse,
		// CollapseItem,   
		// BaseCheckbox,   
		// BaseSwitch, 	
		// ReFilter,		
		[Option.name]: Option,
		[Select.name]: Select,
		// ReInputContact,
		// PresentationNest,
		SimpleWizard,
		WizardTab,
		// StpfstFlats,
		// StpsndOpts,
		// StptrdSendNew
	},
	props: {
		masPresentationObjects: Array,
		tabChange: Function,
		presentTitle: {
			type: String,
			default: 'Презентация создана DateTime',
		}

	},
	data () {
		return {
			ver: 1,      
			bIsTabdisabled: true,  
			bIsSendSection: false,  
			bIsSend: false, 
			//masAllFilterParams: this.currentFilterConfig(),
			linkText: '',
			wizardModel: {},
			/*
			masViewOpts:[
				{
					elementGetParamMap: 'gk_name',
					elementType: 'switcher',
					element_model: true,
					element_model_default: true,
					placeholder: 'Название ЖК',
					label_on: 'Да',
					label_off: 'Нет',
				},
				{
					elementGetParamMap: 'dev_name',
					elementType: 'switcher',
					element_model: true,
					element_model_default: true,
					placeholder: 'Название застройщика',
					label_on: 'Да',
					label_off: 'Нет',
				},
				{
					elementGetParamMap: 'gk_pass',
					elementType: 'switcher',
					element_model: true,
					element_model_default: true,
					placeholder: 'Паспорт ЖК',
					label_on: 'Да',
					label_off: 'Нет',
				},
				{
					elementGetParamMap: 'b_endingperiod',
					elementType: 'switcher',
					element_model: true,
					element_model_default: true,
					placeholder: 'Срок сдачи',
					label_on: 'Да',
					label_off: 'Нет',
				},
				{
					elementGetParamMap: 'app_floor_image',
					elementType: 'switcher',
					element_model: true,
					element_model_default: true,
					placeholder: 'Поэтажный план',
					label_on: 'Да',
					label_off: 'Нет',
				},
				{
					elementGetParamMap: 'gk_photos',
					elementType: 'switcher',
					element_model: true,
					element_model_default: true,
					placeholder: 'Фотографии ЖК',
					label_on: 'Да',
					label_off: 'Нет',
				},
				{
					elementGetParamMap: 'pano',
					elementType: 'switcher',
					element_model: true,
					element_model_default: true,
					placeholder: 'Аэропанорама ЖК',
					label_on: 'Да',
					label_off: 'Нет',
				},
				{
					elementGetParamMap: 'app_pass',
					elementType: 'switcher',
					element_model: true,
					element_model_default: true,
					placeholder: 'Паспорт квартиры',
					label_on: 'Да',
					label_off: 'Нет',
				},
				{
					elementGetParamMap: 'app_decoration',
					elementType: 'switcher',
					element_model: true,
					element_model_default: true,
					placeholder: 'Отделка',
					label_on: 'Да',
					label_off: 'Нет',
				},
				{
					elementGetParamMap: 'app_image',
					elementType: 'switcher',
					element_model: true,
					element_model_default: true,
					placeholder: 'Планировка',
					label_on: 'Да',
					label_off: 'Нет',
				},
				{
					elementGetParamMap: 'b_keyperiod',
					elementType: 'switcher',
					element_model: false,
					element_model_default: false,
					placeholder: 'Срок передачи ключей',
					label_on: 'Да',
					label_off: 'Нет',
				},
				{
					elementGetParamMap: 'banks',
					elementType: 'switcher',
					element_model: false,
					element_model_default: false,
					placeholder: 'Банковские программы',
					label_on: 'Да',
					label_off: 'Нет',
				},
				/*{
					elementGetParamMap: 'mortage_calc',
					elementType: 'switcher',
					element_model: false,
					element_model_default: false,
					placeholder: 'Калькулятор ипотеки',
					label_on: 'Да',
					label_off: 'Нет',
				},* /
				{
					elementGetParamMap: 'anal',
					elementType: 'switcher',
					element_model: false,
					element_model_default: false,
					placeholder: 'Динамика цен',
					label_on: 'Да',
					label_off: 'Нет',
				},
			],
			*/ 
			masClient: [{contacts:[]}],
		}
	},
	methods: {

		setViewObj(){
			
		},
		validateStep(ref) {
			this.$emit('tab-change',ref);

			return false;
			/*
			if(ref == 'step2') this.printPress(); // формируем презентацию
			if(ref == 'step3') this.wizardComplete();
			return this.$refs[ref].validate();
			*/
		},
		/*
		onStepValidated(validated, model) {
			this.wizardModel = { ...this.wizardModel, ...model };
		},
		wizardComplete() {
			//console.log('В визарде нажали финиш');
			const objGetParams = this.$GVO.GetAllGet();
			this.$GVO.ApiCall('RUN_TASK',{obj:'services' ,flt:{'client_id':objGetParams.client_id,'id':objGetParams.task_id,'taskend_id':objGetParams.taskend_id}})
			.then((objApi) => { 
				if(objApi.success === true){
					location.href = '/data/clients/id/'+objGetParams.client_id;
				}
			}).catch(errorObjApi => {console.log(errorObjApi); this.bIsLoading = false;});
		},
		*/
		getClient(){
			const objGetParams = this.$GVO.GetAllGet();
			if(typeof objGetParams.client_id != 'undefined'){
				this.$GVO.ApiCall('GET',{obj:'client' ,flt:{id:objGetParams.client_id}})
				.then((objApi) => { 
					this.bIsLoading = false;
					//console.log(objApi);
					if(objApi.success === true){
						if(typeof this.$GVO.cats['CONTACTS_TYPES'] == 'undefined'){
							this.$GVO.ApiCall('GET_CONTACTS_TYPES',{obj:"staff"})
								.then((objApiCat) => { 
									//console.log('GET_CONTACTS_TYPES',objApi);
									if(objApiCat.success === true){
										this.$GVO.cats['CONTACTS_TYPES'] = objApiCat.data;
										this.masClient = objApi.data;
									}
								}).catch(errorObjApi => {console.error(errorObjApi);});
						}else{
							this.masClient = objApi.data;
						}
					}
				}).catch(errorObjApi => {console.error(errorObjApi); this.bIsLoading = false;});
			}
		},
		// currentFilterConfig() {
		// 	return require("src/conf/presentationFilter.js").super_config;
		// 	return [];
		// },
		sendPress(objSend) {
			/*
			this.bIsSendSection = !this.bIsSendSection;
			this.bIsSend = true;
			*/
			if(objSend.strAddr != '' && objSend.strNote != ''){
				this.$GVO.ApiCall('SEND_PRESENTATION',{obj:'presentations',flt:{'path':this.linkText,'cont_type':'mail','cont_value':objSend.strAddr,'mess_text':objSend.strNote}})
				.then((objApi) => {
					if(objApi.success === true){
						//this.linkText = objApi.data.link;
						this.$GVO.showAlert('Презентация','Презентация отправлена','btn btn-success btn-fill');
					}
				}).catch(errorObjApi => {this.ApiData = []; console.error(errorObjApi);});
			}else{
				alert('адрес или текст сообщения пусто');
			}
		},
		sendToPrint() {
			this.bIsSendSection = !this.bIsSendSection;
			this.bIsSend = false;
		},
		sendCancel() {
			this.bIsSendSection = false;
		},


	},
	mounted(){
	//	this.getClient();
	}
}
</script>

<style scoped>

.RePresentation >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
.RePresentation >>> .nav {flex-wrap: nowrap;}
.RePresentation >>> .row {margin: 0px 0px 5px 0px; justify-content: space-between;}

.presentCard:not(:last-child) {margin-right: 15px;}
.presentCard-row, .btn-row, .btn-left, .btn-right {display: flex;}
.presentCard-row {flex-wrap: wrap;}
.btn-left, .btn-right {flex-wrap: wrap;}
.btn-left button {margin-right: 15px;}
.btn-row {justify-content: space-between; flex-wrap: wrap;}
.presentCard, .presentInfo-row {border: 1px solid #01b0e0; border-radius: 0.2857rem; margin-bottom: 15px;}
.groupTopBlock {border-bottom: 1px solid #01b0e0; padding: 20px 0px;}
.groupBottBlock {padding-top: 10px;}
.groupPhoto {display: flex; width: 100%;}
.groupPhoto img {width: auto; height: 250px; margin: 0 auto; background-color: #fff!important;}
.groupBottBlock >>> button {padding: 10px 12px;}
.sendPresentation, .presentInfo-row, .flat-price, .flat-status {display: flex;}
.presentInfo-row {justify-content: space-between; flex-wrap: wrap; padding: 12px 12px 5px 12px ;}
.flat-info, .flat-checked, .send-title  {display: flex; justify-content: space-between;}
.presentInfo-row p, .flat-price, .flat-status, .flat-info p, .flat-checked {margin-right: 15px; margin-bottom: 5px;}
.sendPresentation >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01b0e0;}
.sendPresentation >>> .card-collapse {width: 100%;}
.text-crossed {text-decoration: line-through;}
.RePresentation >>> .card .card-header {padding-top: 0px;}

/*==========send-section======================================================================*/
.send-section {padding: 15px; border: 1px solid #01b0e0; border-radius: 6px; margin-bottom: 20px;}
.send-title .btn {margin-top: -10px;}
.link-row, .contacts-row, .message-row {display: flex; flex-wrap: wrap;width: 100%;}
.link-input {margin-top: 4px;}
.send-form {width: 100%;}
.send-footer {display: flex; justify-content: center;}
.send-section >>> .tab-space {padding-bottom: 0px;}
.send-section >>> .card {margin-bottom: 0px;}


@media (max-width: 768px){
	.presentCard {margin-right: 0px;}
	.presentInfo-row {flex-direction: column;}
}        
@media (max-width: 575px){
	.link-input {margin-top: 10px; padding: 0px;}
	.link-row .btn {width: 100%;}
}


</style>

